import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type GetTeamParams = {
  organizationId: string;
  teamId: number;
};

type FindTeamsParams = {
  organizationId: string;
  filters: Record<string, any>;
};

type CreateTeamParams = {
  organizationId: string;
};

function getTeamsHelper(organizationId: string) {
  return clientApi.getOCClient().helpers.employer.organizations.id(organizationId).teams;
}

const {
  useGet: useOrganizationTeam,
  useFind: useOrganizationTeams,
  useCreate: useOrganizationTeamCreation,
  useDelete: useOrganizationTeamDeletion,
} = getCRUDHooks({
  entityName: 'organizationTeam',
  get: ({ organizationId, teamId }: GetTeamParams) => getTeamsHelper(organizationId).get(teamId),
  find: ({ organizationId, filters }: FindTeamsParams) =>
    getTeamsHelper(organizationId).find(filters),
  create: (newTeam: any, { organizationId }: CreateTeamParams) =>
    getTeamsHelper(organizationId).create(newTeam),
  remove: (teamId: string) => clientApi.getOCClient().helpers.employer.teams.delete(teamId),
});

export {
  useOrganizationTeam,
  useOrganizationTeams,
  useOrganizationTeamCreation,
  useOrganizationTeamDeletion,
};
